export enum CardsStackedVariants {
  Copy = 'Copy',
  Image = 'Image',
  ImageV2 = 'Image V2',
  Icon = 'Icon',
}
